import type { SearchProvider, SearchResult } from "../types";
import type ApiService from "../../ApiService";
import { softContains } from "../../../utils/stringUtil";
import { isNil } from "lodash-es";
import { flatMap, takeWhere } from "../searchUtil.ts";
import type CustomerId from "../../../state/CustomerId.ts";
import { createFormSearchResult } from "./FormSearchResult.tsx";

export class FormSearchProvider implements SearchProvider {
  readonly type = "FORM";

  constructor(
    private readonly customerId: CustomerId,
    private readonly foldersQuery: ReturnType<typeof ApiService.getFolders>,
    private readonly maxResults: number,
  ) {}

  async search(query: string): Promise<SearchResult[]> {
    if (isNil(this.foldersQuery.data)) {
      return [];
    }

    return Array.from(
      takeWhere(
        flatMap(this.foldersQuery.data, function* (folder) {
          for (const form of folder.forms) {
            yield { folder, form };
          }
        }),
        ({ form }) =>
          form.status === "ACTIVE" &&
          (form.id.equals(query) ||
            softContains(form.meta.name, query) ||
            softContains(form.meta.description ?? "", query)),
        this.maxResults,
      ).map(({ folder, form }) => ({
        type: this.type,
        ...createFormSearchResult({ form, folder, customerId: this.customerId }),
      })),
    );
  }
}
